export const DEFAULT_LOGO_SIZE = { height: 24, width: 150 };
export const BIG_LOGO_SIZE = { height: 36, width: 225 };
